import { Pressable, ScrollView, StyleSheet, View } from "react-native";

import { GText } from "@/components/g-text";
import { colors } from "@/constants/colors";

interface Props {
  onClear?: () => void;
  onSelectDuration: (minutes: number) => void;
  optional?: boolean;
  selectedMinutes: null | number;
}

const ROW_HEIGHT = 48;

function formatDuration(totalMinutes: number): string {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) return `${minutes}min`;
  if (minutes === 0) return hours === 1 ? "1 hour" : `${hours} hours`;
  return `${hours}h ${minutes}min`;
}

// Generate slots: 15min increments from 15min to 12 hours
const DURATION_SLOTS: number[] = [];
for (let m = 45; m <= 720; m += 15) {
  DURATION_SLOTS.push(m);
}

export function DurationPickerList({
  onClear,
  onSelectDuration,
  optional,
  selectedMinutes,
}: Props) {
  const defaultIndex = DURATION_SLOTS.indexOf(120); // 2 hours

  return (
    <View>
      <ScrollView
        contentOffset={{
          x: 0,
          y: Math.max(
            0,
            (selectedMinutes
              ? DURATION_SLOTS.indexOf(selectedMinutes)
              : defaultIndex) *
              ROW_HEIGHT -
              ROW_HEIGHT * 2,
          ),
        }}
        showsVerticalScrollIndicator={false}
        style={styles.list}
      >
        {DURATION_SLOTS.map((minutes) => {
          const isSelected = minutes === selectedMinutes;
          return (
            <Pressable
              key={minutes}
              onPress={() => onSelectDuration(minutes)}
              style={[styles.row, isSelected && styles.rowSelected]}
            >
              <GText
                style={[styles.rowText, isSelected && styles.rowTextSelected]}
              >
                {formatDuration(minutes)}
              </GText>
            </Pressable>
          );
        })}
      </ScrollView>
      {optional && (
        <Pressable onPress={onClear} style={styles.clearButton}>
          <GText style={styles.clearText}>Clear</GText>
        </Pressable>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  clearButton: {
    alignItems: "center",
    marginTop: 16,
    paddingVertical: 10,
  },
  clearText: {
    color: colors.subtle,
    fontSize: 14,
  },
  list: {
    maxHeight: ROW_HEIGHT * 7,
  },
  row: {
    alignItems: "center",
    borderRadius: 8,
    height: ROW_HEIGHT,
    justifyContent: "center",
    marginVertical: 2,
  },
  rowSelected: {
    backgroundColor: colors.white,
  },
  rowText: {
    color: colors.white,
    fontSize: 16,
  },
  rowTextSelected: {
    color: colors.black,
    fontWeight: "600",
  },
});
